export const PAYMENT_TYPE = {
  SUBSCRIPTION: 'subscription',
  RENT: 'rent',
  PURCHASE: 'sale',
  MEMBER_ONLY: 'memberOnly',
};

export const PAYMENT_PERMS = {
  [PAYMENT_TYPE.SUBSCRIPTION]: ['unlimitedStreaming', 'instantAccess', 'monthlyPayment'],
  [PAYMENT_TYPE.PURCHASE]: ['singleVideo', 'onePayment', 'unlimitedStreaming'],
  [PAYMENT_TYPE.RENT]: ['singleVideoStreaming', 'streamingPeriod'],
  [PAYMENT_TYPE.MEMBER_ONLY]: ['singleVideo', 'unlimitedStreaming'],
};



// WEBPACK FOOTER //
// ./src/shared/constants/payments.js